import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";

const Avatar = forwardRef(
  (
    {
      className,
      src,
      alt = "",
      size = "md",
      fallback,
      children,
      ...props
    },
    ref
  ) => {
    const sizeClasses = {
      sm: "h-8 w-8 text-xs",
      md: "h-10 w-10 text-sm",
      lg: "h-12 w-12 text-base",
      xl: "h-16 w-16 text-lg",
    };
    
    const baseClasses = "inline-flex items-center justify-center rounded-full bg-warm-200 text-warm-700 overflow-hidden";
    
    return (
      <div
        ref={ref}
        className={cn(
          baseClasses,
          sizeClasses[size] || sizeClasses.md,
          className
        )}
        {...props}
      >
        {src ? (
          <img
            src={src}
            alt={alt}
            className="h-full w-full object-cover"
          />
        ) : fallback ? (
          <span className="font-semibold">{fallback}</span>
        ) : children ? (
          children
        ) : null}
      </div>
    );
  }
);

Avatar.displayName = "Avatar";

export default Avatar;